<stages-card
	[toolbarId]="toolbarId"
	[toolbarItems]="toolbarItems!"
	[menuId]="menuId"
	[menuItems]="menuItems!"
	[menuNoCollapse]="menuNoCollapse"
	[showHeader]="showTabs"
>
	<header class="contains-scrollable-tabs" *ngIf="areTabTitlesVisible">
		<stages-tabs>
			<stages-tab *ngFor="let tab of tabs" [routerLink]="$any(tab.routerLink)" [queryParams]="tab.queryParams">
				<h5 *ngIf="tab.literal">{{ tab.title }}</h5>
				<h5 *ngIf="!tab.literal" [translate]="tab.title"></h5>
			</stages-tab>
		</stages-tabs>
	</header>
	<div class="panel" *ngIf="$any(tabs?.length) > 0">
		<router-outlet></router-outlet>
	</div>
</stages-card>
